<template>
  <div class="step-restricoes">
    <Restricao :item="item" :regioesRepresentantes="regioesRepresentantes" />
  </div>
</template>

<script>
import Restricao from "../components/Restricao/Restricao.vue";

export default {
  name: "StepRestricoes",
  components: { Restricao },
  props: {
    item: {
      type: Object,
      required: true,
    },
    regioesRepresentantes: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
